import './RotatePhone.scss';
import { isMobile } from '../../platform/utils';
import { useTranslation } from '../../platform/stores';

export const RotatePhone = () => {
  const t = useTranslation();
  return (
    <>
      {
        isMobile()
          ?
          <div className="rotate-phone-component">
            <div className="phone"></div>
            <div className="message">{t('PLEASE_ROTATE_YOUR_DEVICE')}</div>
          </div>
          :
          <></>
      }
    </>
  );
}
